/* eslint-disable no-redeclare */
import {
  Domain,
  HealthcareSessionId,
  HealthcareUserId,
  Integer,
  IpAddress,
  NonEmptyText,
  Source,
  Url,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const LeadId = Integer;

export type LeadId = z.infer<typeof LeadId>;

export const CreateProspectParameters = z.object({
  sessionId: HealthcareSessionId,
  userId: HealthcareUserId,
  landingUrl: Url,
  host: Domain,
  ipAddress: IpAddress,
  userAgent: NonEmptyText,
  source: Source.optional(),
});

export type CreateProspectParameters = z.input<typeof CreateProspectParameters>;
